import { Checkbox, FormControlLabel, Tooltip } from '@mui/material';
import { Controller } from 'react-hook-form';

import type { CompoundSubjectAndAction } from '@inspiren-monorepo/feature-permissions';

import { allPermissions } from '../constants/permissions';

import type { Control } from 'react-hook-form';

type Props = {
  id: CompoundSubjectAndAction;
  label: string;
  control: Control;
  tooltip?: string;
  disabled?: boolean;
  setValue?: any;
  fallRiskOffPermission?: boolean;
};

const RoleControlledCheckMarks = ({
  id,
  label,
  control,
  tooltip,
  disabled = false,
  setValue,
  fallRiskOffPermission,
}: Props) => (
  <Controller
    name={id}
    control={control}
    render={({ field: { name, value } }) => (
      <Tooltip
        title={
          fallRiskOffPermission && name === 'global.fall-risk-high-low.view'
            ? 'You cannot uncheck this while "Set Fall Risk to Fall Only" is checked'
            : tooltip
        }
        placement='top'
        disableHoverListener={!tooltip && !fallRiskOffPermission}
        disableInteractive={!tooltip && !fallRiskOffPermission}
        disableFocusListener={!tooltip && !fallRiskOffPermission}
      >
        <FormControlLabel
          control={<Checkbox />}
          defaultChecked={false}
          id={name}
          label={label}
          checked={value || false}
          onChange={(e: any) => {
            if (setValue && !e.target.checked) {
              if (
                fallRiskOffPermission &&
                name === 'global.fall-risk-high-low.view'
              ) {
                return;
              }

              const permissions = allPermissions.filter((permission) => {
                const subjectWithAction = name.split('.');
                subjectWithAction.pop();
                const subject = subjectWithAction.join('.');
                return permission.id.includes(subject);
              });

              permissions.forEach((permission) => {
                setValue(permission.id, e.target.checked);
              });
            }

            if (setValue && e.target.checked) {
              if (name === 'global.fall-risk-off.view') {
                setValue('global.fall-risk-high-low.view', e.target.checked);
              }

              setValue(name, e.target.checked);
            }
          }}
          sx={{ display: 'block', my: 1 }}
          disabled={disabled}
        />
      </Tooltip>
    )}
  />
);

export default RoleControlledCheckMarks;
